import { render, staticRenderFns } from "./problemDes.vue?vue&type=template&id=96ba3922&scoped=true"
import script from "./problemDes.vue?vue&type=script&lang=js"
export * from "./problemDes.vue?vue&type=script&lang=js"
import style0 from "./problemDes.vue?vue&type=style&index=0&id=96ba3922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ba3922",
  null
  
)

export default component.exports